import React, { useState, useEffect } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { API_ENDPOINTS } from '../../config/api';
import './VoteModal.css';

interface VoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  prepopulatedUniversity?: string;
}

const VoteModal: React.FC<VoteModalProps> = ({ isOpen, onClose, onSuccess, prepopulatedUniversity }) => {
  const { isDarkMode } = useTheme();
  const [universityName, setUniversityName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setUniversityName(prepopulatedUniversity || '');
      setError('');
    }
  }, [isOpen, prepopulatedUniversity]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = universityName.trim();
    if (!trimmed) {
      setError('Enter a location to vote.');
      return;
    }

    // Show thanks immediately; submit in the background
    onClose();
    onSuccess?.();

    fetch(API_ENDPOINTS.VOTE_UNIVERSITY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        university_name: trimmed,
      }),
    }).catch((err) => {
      console.error('Error submitting vote:', err);
    });
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="vote-modal-overlay" onClick={handleClose}>
      <div 
        className={`vote-modal ${isDarkMode ? 'dark' : 'light'}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="vote-modal-header">
          <h2>Request a location</h2>
          <button 
            className="vote-modal-close" 
            onClick={handleClose}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="vote-form">
          {error && <div className="vote-error">{error}</div>}
          
          <div className="vote-form-group">
            <input
              type="text"
              id="universityName"
              aria-label="University or city"
              value={universityName}
              onChange={(e) => setUniversityName(e.target.value)}
              placeholder="University or city"
              required
              autoFocus
            />
          </div>
          
          <div className="vote-form-actions">
            <button
              type="button"
              onClick={handleClose}
              className="vote-cancel-btn"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="vote-submit-btn"
            >
              Vote
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VoteModal;
